<style lang="scss" src='./TaskDetails.scss' scoped></style>
<template src="./TaskDetails.html"></template>

<script>
import { Consts } from 'gw-js-lib';
import {
  mapState,
  mapActions,
} from 'vuex';

import TaskDetailsComments from '@/components/comments/TaskDetailsComments.vue';
import UserAvatar from '@/components/user/avatar/UserAvatar.vue';
import MapRedFlag from '@/assets/img/gw/flags/ic_flag_red.png';

export default {
  components: {
    TaskDetailsComments,
    UserAvatar,
  },
  data() {
    return {
      comment: null,
      map: {},
      google: {},
    };
  },
  computed: {
    ...mapState('TaskBoard', ['taskSelected','filterStatusList','loading']),
    ...mapState(['user']),
  },
  methods: {
    ...mapActions('TaskBoard', ['updateTask', 'addComment']),
    async validateData() {
      await this.addComment(this.comment);
      this.comment = null;
    },
    async initMap({ lat = 0, lng = 0 }) {
      const mapOptions = {
        mapId: 'map',
        zoom: 18,
        center: { lat, lng },
        controlOptions: {
          mapTypeControl: false,
          scaleControl: false,
          streetViewControl: false,
          rotateControl: false,
        },
      };

      this.map = await this.G_initMap(mapOptions);
      this.google = this.consts.Google.MAP;
      const newMark = new window.google.maps.Marker({
        position: { lat, lng },
        icon: (this.taskSelected.alert_id != null) ? MapRedFlag : '',
      });

      if (this.map && this.google && this.google.maps) {
        newMark.setAnimation(this.google.maps.Animation.BOUNCE);
        newMark.setMap(this.map);
        // eslint-disable-next-line
        setTimeout(function() {
          newMark.setAnimation(null);
        }, 1500);
      }
    },
  },
  mounted(){
    if(this.taskSelected.latitude){
      this.initMap( { lat: this.taskSelected.latitude, lng: this.taskSelected.longitude } );
    };
  }
};
</script>
